import { Permission } from '@cims-online/shared'
import { RestoreRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { IssueType } from '../../IssueTypesContext/types'
import { useIssueTypesContext } from '../../IssueTypesContext'
import { useRestoreIssueTypeMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleRestoreNotification } from 'hooks/notificationHandler'

export function useRestore(): RestoreRowActionOptions<IssueType> {
  const { refetch } = useIssueTypesContext()
  const [restore] = useRestoreIssueTypeMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      restoreIssueType: {
        type: { name },
      },
    }) => simpleRestoreNotification(name),
  })
  return {
    permission: Permission.RemoveRestoreIssueType,
    default: 'active',
    metadata: ({ deleted, deletedDate, deletedUser }) => ({
      removed: deleted,
      removedBy: deletedUser,
      removedDate: deletedDate,
    }),
    onRestore: async ({ id }) => {
      await restore({ variables: { id } })
      refetch()
    },
  }
}
